import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Parser from 'html-react-parser';

const FormGroup = ({
    errors: propErrors,
    label,
    labelClass,
    fieldClass,
    className,
    children,
    button
}) => {
    const [errors, setErrors] = useState(propErrors || []);

    useEffect(() => {
        setErrors(propErrors || []);
    }, [propErrors]);

    const getClassGroup = () => {
        return classNames({
            'form-group': true,
            'has-error': errors.length,
            ...className
        });
    };

    const getErrors = () => {
        return errors.join('<br/>');
    };

    return (
        <div className={getClassGroup()}>
            {label
                ? <label className={`control-label ${labelClass ? labelClass : ''}`}>
                    {Parser(label)}
                  </label>
                : null
            }
            <div className={fieldClass ? fieldClass : ''}>
                {children}
                {errors.length
                    ? <span className="error-message help-block">{Parser(getErrors())}</span>
                    : null
                }
            </div>
            {button}
        </div>
    );
};

FormGroup.propTypes = {
    errors: PropTypes.array,
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    labelClass: PropTypes.string,
    fieldClass: PropTypes.string,
    className: PropTypes.object,
    children: PropTypes.node,
    button: PropTypes.node
};

FormGroup.defaultProps = {
    errors: [],
    label: '',
    labelClass: '',
    fieldClass: '',
    className: {},
    children: null,
    button: null
};

export default FormGroup;
